export const useClientIdentificator = () => {
	const isDev = process.env.NODE_ENV === "development";

	let client = "";
	let environment = "";

	if (isDev) {
		client = process.env.REACT_APP_TENANT || "";
		environment = process.env.REACT_APP_TENANT_ENVIRONMENT || "";
	} else {
		const host = window.location.host || "";
		const parts = host.split(".");

		if (parts.length === 4) {
			client = parts[0];
			environment = parts[1];
		} else if (parts.length === 3) {
			const subdomain = parts[0];
			const subdomainParts = subdomain.split("-");

			if (subdomainParts.length > 1) {
				environment = subdomainParts[subdomainParts.length - 1] || "";
				client = subdomainParts.slice(0, -1).join("-");
			} else {
				client = subdomain;
			}
		}

		client = client.replace(/-/g, "");
	}

	return {
		client,
		environment,
		clientEnvironment: environment
			? `${client}-${environment}`
			: client,
	};
};